export default __webpack_public_path__ + "static/gift-card-6.url-1b570c48ca3e6d9ac7a8c568121d71cd.svg";